import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import SignUpFormContent from '../components/SignUpFormComponent'
import { useChangeEmailForm } from './ChangeEmailForm.hooks'

const ChangeEmailForm = props => {
	const [
		{
			buttonText,
			classes,
			className,
			data,
			settings,
			formikProps,
			fieldsPerRow,
			placeholderColor,
			title,
			usePaperColors,
			titleEditable,
			buttonTextConfig,
			titleConfig,
			buttonTextEditable,
			buttonTextKey,
			titleKey,
			captchaRef,
			withCaptcha,
		},
		{ handleButtonClick, handleTitleClick, handleFormSubmit, handleTitleChange, handleButtonTextChange },
	] = useChangeEmailForm(props)

	return (
		<Formik {...formikProps} onSubmit={handleFormSubmit}>
			{({ handleSubmit, isSubmitting }) => (
				<SignUpFormContent
					className={className}
					placeholderColor={placeholderColor}
					buttonText={buttonText}
					usePaperColors={usePaperColors}
					title={title}
					titleConfig={titleConfig}
					classes={classes}
					fieldsPerRow={fieldsPerRow}
					settings={settings}
					handleSubmit={handleSubmit}
					isSubmitting={isSubmitting}
					captchaRef={captchaRef}
					withCaptcha={withCaptcha}
					data={data}
					withOptin={!formikProps.initialValues.opt_in}
					onButtonClick={handleButtonClick}
					onTitleClick={handleTitleClick}
					titleEditable={titleEditable}
					onTitleChange={handleTitleChange}
					buttonTextEditable={buttonTextEditable}
					buttonTextConfig={buttonTextConfig}
					onButtonTextChange={handleButtonTextChange}
					titleKey={titleKey}
					buttonTextKey={buttonTextKey}
				/>
			)}
		</Formik>
	)
}

ChangeEmailForm.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		checkboxes: PropTypes.string,
		item: PropTypes.string,
		checkboxItem: PropTypes.string,
		buttonProgress: PropTypes.string,
		optIn: PropTypes.string,
		button: PropTypes.string,
		buttonText: PropTypes.string,
		privacy: PropTypes.string,
		link: PropTypes.string,
		title: PropTypes.string,
		input: PropTypes.string,
		checkbox: PropTypes.string,
		select: PropTypes.string,
	}),
	buttonText: PropTypes.string,
	title: PropTypes.string,
	titleConfig: PropTypes.object,
	placeholderColor: PropTypes.string,
	usePaperColors: PropTypes.bool,
	fieldsPerRow: PropTypes.oneOf([1, 2, 3, 4]),
	onSuccess: PropTypes.func,
	onTitleClick: PropTypes.func,
	onButtonClick: PropTypes.func,
	titleEditable: PropTypes.bool,
	onTitleChange: PropTypes.func,
	buttonTextEditable: PropTypes.bool,
	buttonTextConfig: PropTypes.object,
	onButtonTextChange: PropTypes.func,
	titleKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	buttonTextKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

ChangeEmailForm.defaultProps = {
	onSuccess: () => {},
}

export default memo(ChangeEmailForm)
